import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFulfillmentCenter } from 'src/hooks/useFulfillmentCenter'
import { formatDatePlusThree } from 'src/utils/formatDate'
import { selectClickExecuteInventory, selectInventoriesToExecute } from '../../InventorySelector'
import { actions } from '../../InventoryState'
import { FormStartExecution } from '../FormStartExecution/FormStartExecution'
import * as S from './TableInventoriesToExecute.styles'

export const TableInventoriesToExecute = ({ setInitialState }) => {
  const dispatch = useDispatch()
  const [inventoryToExecute, setInventoryToExecute] = useState()
  const [searchName, setSearchName] = useState('')
  const clickExecute = useSelector(selectClickExecuteInventory)
  const inventoriesToExecute = useSelector(selectInventoriesToExecute)
  const { fc, validateFc } = useFulfillmentCenter()

  useEffect(() => {
    validateFc()
  }, [validateFc])

  useEffect(() => {
    dispatch(actions.getInventoriesToExecute(fc.id))
  }, [dispatch, fc.id, inventoriesToExecute.length])

  const onClickExecute = (i) => {
    dispatch(actions.setClickExecuteInventory(true))
    setInitialState(true)
    setInventoryToExecute(i)
  }

  const filterInventories = () => {
    let filteredInventories = inventoriesToExecute

    if (searchName) {
      filteredInventories = filteredInventories.filter(
        (inventory) => inventory.inventoryName.toLowerCase().includes(searchName.toLowerCase()),
      )
    }
    return filteredInventories
  }

  const inventories = filterInventories().length > 0 ? filterInventories().map((i, index) => (
    <S.ContainerInventories key={index}>
      <p><strong>Nome:</strong> {i.inventoryName}</p>
      <p><strong>Data de criação:</strong> {formatDatePlusThree(i.createdAt)}</p>
      <p><strong>Status:</strong> {i.currentStatus}</p>
      <S.CustomButtonExecute
        title='Iniciar'
        bgColor='blue'
        hoverColor='darkBlueHover'
        data-testid='button-execute-test'
        letterColor='white'
        onClick={() => onClickExecute(i)}
      />
    </S.ContainerInventories>
  )) : <S.ContainerWithoutInventories> <p>Nenhum inventário para executar</p> </S.ContainerWithoutInventories>

  if (clickExecute) return <FormStartExecution inventoryToExecute={inventoryToExecute} />

  return (
    <S.Wrapper>
      <S.ContainerText>
        <S.CustomTextField
          type='text'
          name='searchName'
          id='searchName'
          variant='outlined'
          value={searchName}
          label='filter.by.name.inventory'
          onChange={(e) => setSearchName(e.target.value)}
          data-testid='searchName-input-test'
        />
      </S.ContainerText>
      {inventories}
    </S.Wrapper>
  )
}
